import { render, staticRenderFns } from "./GearSlot.vue?vue&type=template&id=fa3c1ca8&"
import script from "./GearSlot.vue?vue&type=script&lang=js&"
export * from "./GearSlot.vue?vue&type=script&lang=js&"
import style0 from "./GearSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports